/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MessageItemAliases {
  ACTION_FILES = 'action-files',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  FIELD_MESSAGE_ITEM_MESSAGE = 'field-message-item-message',
  FIELD_MESSAGE_ITEM_SUBJECT = 'field-message-item-subject',
  FORM_MESSAGE = 'form-message',
  INPUT_MESSAGE_ITEM_SUBJECT = 'input-message-item-subject',
  LAYOUT_MESSAGE_ITEM = 'layout-message-item',
  PANEL_CONTENT = 'panel-content',
  TEXT_AREA_MESSAGE_ITEM_MESSAGE = 'text-area-message-item-message',
}
export { MessageItemAliases };
